{
  "name": "youboralib",
  "type": "lib",
  "tech": "js",
  "author": "Nice People At Work",
  "version": "6.8.54",
  "built": "2024-04-05",
  "repo": "https://bitbucket.org/npaw/lib-plugin-js.git"
}